<template>
    <section class="content-header">
        <div class="container-fluid">
            <div class="row mb-0" style=" margin-top: -15px !important;">
                <div class="col-sm-6 d-none d-sm-block d-sm-none d-md-block">
                    <h4>{{storeMenu.getClassApps[extraMessage($route.path.split('/')[1])].message}}</h4>
                </div>
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">
                        <li class="breadcrumb-item"><b>{{ extractUrl(route.path)}}</b></li>
                    </ol>
                </div>
            </div>
        </div><!-- /.container-fluid -->
    </section>
</template>

<script lang="ts" setup>
    import { useRoute } from 'vue-router'
    import { useMenuStore } from '@/stores/MenuStore'
    const storeMenu = useMenuStore();  
    const route = useRoute()
    const extraMessage = (value: string) => {
        if (value.length == 0) return "Home";
         else  return value
    }
    const extractUrl = (value: string) => {
        if (value.length < 2) return "Home";
         else  return value
    }
</script>